import { createTheme } from '@mui/material/styles';

export const colors = {
  ink: '#0b1634', muted: '#657797', blue: '#0878ff', bronze: '#a5652c',
  navy: '#192b3e', canvas: '#f3f7fc', border: '#e4ebf4', green: '#17a76c',
};

const theme = createTheme({
  palette: {
    primary: { main: colors.blue }, secondary: { main: colors.bronze },
    text: { primary: colors.ink, secondary: colors.muted },
    background: { default: colors.canvas, paper: '#fff' },
    success: { main: colors.green }, error: { main: '#e63356' }, divider: colors.border,
  },
  shape: { borderRadius: 4 },
  typography: {
    fontFamily: '"Segoe UI", Arial, sans-serif',
    h4: { fontSize: '1.9rem', fontWeight: 750, letterSpacing: '-.045em' },
    h5: { fontWeight: 750, letterSpacing: '-.025em' },
    h6: { fontSize: '1.05rem', fontWeight: 700, letterSpacing: '-.02em' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 8, padding: '9px 18px' } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' }, rounded: { borderRadius: 14 } } },
    MuiCard: { styleOverrides: { root: { border: `1px solid ${colors.border}`, boxShadow: '0 4px 22px #172b4d04' } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 7, background: '#fff' }, notchedOutline: { borderColor: '#d9e3ef' } } },
    MuiTableCell: { styleOverrides: { root: { borderBottom: '1px solid #eef2f7', padding: '14px 16px' }, head: { background: '#f5f8fd', color: '#536687', fontWeight: 650, fontSize: '.78rem', textTransform: 'none' } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 7, fontWeight: 600 }, colorSuccess: { background: '#e3f7ef', color: '#087f50' }, colorError: { background: '#ffedf1', color: '#c82248' } } },
    MuiTab: { styleOverrides: { root: { textTransform: 'none', minHeight: 50, fontWeight: 600 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 16 } } },
  },
});
export const publicTheme = createTheme(theme, { palette: { primary: { main: colors.bronze } } });
export default theme;
